import React, { FC } from 'react'
import classNames from 'classnames'
import { addStoreLocaleByCookie } from 'lib/storeLocale/client'
import Modal from 'components/Modal/v2'
import Recaptcha, { getCaptchaToken } from 'components/Form/Recaptcha'
import { Content } from 'styles/modals'
import { ConfirmationModal } from './styles'
import { postConvertCollectorAccountToArtistAccount } from 'apis/private/user'

type Props = {
  closeModal: (...args: Array<any>) => any
  addMessage: (...args: Array<any>) => any
  modalName: string
}

const Component: FC<Props> = (props) => {
  const { closeModal, addMessage, modalName } = props

  const handleClick = async (ev: React.SyntheticEvent<HTMLElement>) => {
    ev.preventDefault()

    const captchaAction = 'convert_collector_to_artist'
    const captchaToken = await getCaptchaToken(captchaAction)
    const apiResponse = await postConvertCollectorAccountToArtistAccount({
      captchaAction,
      captchaToken,
    })

    if (Boolean(apiResponse?.captchaRequired)) {
      const flashErrorMessage =
        'Something went wrong. Try again or contact our team for additional support.'
      addMessage(flashErrorMessage, 'error')
      return
    }

    if (apiResponse.success) {
      const location = addStoreLocaleByCookie('/studio')
      window.location.href = location
      addMessage('Success', 'success')
    } else {
      const flashErrorMessage = 'Problem changing user type'
      addMessage(flashErrorMessage, 'error')
    }
  }

  return (
    <Modal name={modalName}>
      <ConfirmationModal>
        <h4 className='defaultTypographyH4' data-style='header'>
          Are You Sure You Want To Create An Artist Account?
        </h4>

        <Content>
          <p className={classNames('defaultTypographyMedium', 'defaultTextCenter')}>
            This action will create an "Artist" account, which will give you the ability to upload
            and sell art once you complete our verification process. This action cannot be reversed.
          </p>
          <div data-type='modal-button-row'>
            <button
              onClick={(ev) => {
                ev.preventDefault()
                closeModal()
              }}
              type='button'
              data-type='cancel-button'
            >
              Cancel
            </button>
            <button
              type='button'
              data-type='continue-button'
              onClick={(ev) => {
                handleClick(ev)
                closeModal()
              }}
            >
              Continue
            </button>
          </div>
        </Content>
        <Recaptcha />
      </ConfirmationModal>
    </Modal>
  )
}

export default Component
